<template>
  <div class="col-12">
    <p class="text-center mt-5">Step 2 / 5</p>
    <div class="text-center">
      <h1>Upload Documents</h1>
      <h2>Please provide the documents <br />indicated below</h2>
      <p>Copy of ID, Proof of residence, Passport sized photos</p>
      <small
        >To avoid delays, make sure your documents are scanned cleanly and all
        fields a clearly visible</small
      >
    </div>

    <div class="row d-flex justify-content-center align-items-center mt-5">
      <div class="col-10 col-lg-6">
        <form
          v-bind:class="{ 'ui form loading': isBusy() }"
          @submit.prevent="uploadFiles()"
        >
          <div class="row">
            <div class="col d-flex align-items-center">
              <a-select @change="startImageUpload">
                <a-select-option
                  v-for="fileType of model.fileTypes"
                  :key="fileType.name"
                >
                  {{ fileType.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>

          <br />

          <a-upload-dragger
            v-if="showFileUploader"
            name="file"
            :before-upload="beforeUpload"
            @change="storeImageUpload"
          >
            <p class="ant-upload-drag-icon">
              <InboxOutlined style="color:purple" />
            </p>
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p class="ant-upload-hint">
              You can upload multiple files at once
            </p>
          </a-upload-dragger>

          <div class="row mt-5">
            <h3 class="col-4">Type</h3>
            <h3 class="col-4">File name</h3>
            <h3 class="col-4">Size</h3>
          </div>
          <div
            v-for="s of model.files"
            v-bind:key="s.dataType"
            class="row border-top mt-1 pt-1"
          >
            <p class="col-4">{{ s.type }}</p>
            <p class="col-4">{{ s.name }}</p>
            <p class="col-4">{{ (s.size / 1028).toFixed(2) }} KB</p>
          </div>

          <small v-if="errors.otp" class="text-danger">{{ errors.otp }}</small>
          <small v-if="errors.messageNotReadable" class="text-danger">{{
            errors.messageNotReadable
          }}</small>
          <small v-if="errors.generalExceptionx" class="text-danger">{{
            errors.generalException
          }}</small>
          <small v-if="errors.apiException" class="text-danger">{{
            errors.apiException
          }}</small>

          <button
            class="fluid ui button mt-3"
            v-bind:disabled="isBusy()"
            type="submit"
          >
            Submit
          </button>
          <br />
          <a @click="close()" class="fluid ui grey tertiary button">Cancel</a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";
import { utils } from "@/utils/utils";
import { Notify } from "@/utils/notifications";
import { InboxOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

export default {
  name: "UploadDocuments",
  components: {
    InboxOutlined,
  },
  data() {
    return {
    customer : {
  mobileNumber : localStorage.getItem("phone-number"),
        firstName: "",
        lastName: "",
        identityDocNo: "",
        gotCustomerData: false,
        requestType: "PROCESS_ISAVE_ACCOUNT",

  },
      model: {
        // list of objs
        files: [],
        fileTypes: [],
        docTypes: [],
      },
      tmpFileType: "",
      showFileUploader: false,
      errors: {},
      operations: 0,
      columns: [
        {
          title: "Type",
          dataIndex: "dataType",
          key: "dataType",
        },
      ],
    };
  },
  methods: {
    startImageUpload(item) {
      this.tmpFileType = item;
      this.showFileUploader = true;
    },
    storeImageUpload(info) {
      this.model.docTypes.push();
      this.model.files.push(info.file);
      this.model.docTypes.push(this.tmpFileType);
      this.model.files.splice(-1);
      console.table(this.model.files);
      console.table(this.model.docTypes);

      this.showFileUploader = false;
    },

    uploadFiles() {
      if (this.model.files.length === 0) {
        Notify.fire("Oops", "You forgot to upload a file", "error");
        return;
      }

      const { files } = this.model.files;
      const { docTypes } = this.model.docTypes;
      let formData = new FormData();
      formData.append("phone", localStorage.getItem("mobile"));
      formData.append("customerUid", "e49bb8e5-77ba-4427-842f-5c980c74b930");
      formData.append("documentTypeLabel", "IDENTITY");
      formData.append("citizenId", "082095363P41");
      console.log(formData);
      console.log(files);
      console.log(this.model.files);
      console.log(docTypes);
      this.model.files.forEach((file) => {
        formData.append("files", file);
      });
      this.model.docTypes.forEach((docType) => {
        formData.append("docTypes", docType);
      });

      this.addOp();

      http
        .postFormDataNoAuth(URLS.documents + "/upload", formData)
        .then((res) => {
          utils.logger("upload result", res);
          this.removeOp();
          return this.handleGetResponse(res, true);
        })
        .then((res) => {
          if (!res) return;
          if (res.errors) return (this.errors = res.errors);
          this.postAccountOpeningAsync(
            URLS.processAccount,
            this.customer,
            "Got Customer Data",
            null,
            true
          );
          this.$router.push("/account-opening/isave-complete");
        });
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Document must be smaller than 2MB!");
        return false;
      }

      this.model.files = [...this.model.files, file];
      return false;
    },
    getTypes() {
      http
        .getNoAuth(import.meta.env.VITE_SSO_API, URLS.get_documents)
        .then((response) => (this.model.fileTypes = response.body));

      console.log(this.model.fileTypes);
    },
    ...baseMethods,
  },
  mounted() {
    this.getTypes();
  },
};
</script>

<style scoped></style>
